var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('h4',[_vm._v(" Envie uma mensagem: ")]),_c('p',[_c('a',{attrs:{"href":"mailto:ibram.educ@gmail.com"}},[_vm._v("ibram.educ@gmail.com")])])])
}]

export { render, staticRenderFns }